import { useSearchParams } from 'react-router-dom';
import { SwapOutlined } from '@ant-design/icons';
import { Radio, Skeleton } from 'antd';
import { useTranslation } from '@govard/i18n-core/react';
import { EntityHistoryFeed } from '../../../components/entity-detail/EntityHistoryFeed.js';
import type { DealHistoryItem } from '../hooks/useDealHistory.js';

export function DealHistoryTab({
  items,
  loading,
  error,
  onRetry,
}: {
  items: DealHistoryItem[];
  loading: boolean;
  error: Error | null;
  onRetry: () => void;
}) {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const requestedFilter = params.get('historyFilter');
  const filter = ['stages', 'tasks', 'notes'].includes(requestedFilter ?? '')
    ? requestedFilter
    : 'all';
  const filtered = items.filter(
    (item) =>
      filter === 'all' ||
      (filter === 'stages'
        ? item.kind === 'deal_stage_changed'
        : item.kind.startsWith(filter === 'tasks' ? 'task_' : 'note_')),
  );
  return (
    <>
      <div className="entity-list-toolbar">
        <Radio.Group
          optionType="button"
          buttonStyle="solid"
          size="small"
          value={filter}
          onChange={(event) => {
            const next = new URLSearchParams(params);
            next.set('historyFilter', String(event.target.value));
            setParams(next, { replace: true });
          }}
          options={['all', 'stages', 'tasks', 'notes'].map((value) => ({
            value,
            label: t(`crm.deal_detail.history_${value}`),
          }))}
        />
      </div>
      {loading ? (
        <Skeleton active />
      ) : error ? (
        <ErrorState title={t('crm.entity_detail.load_error')} onRetry={onRetry} />
      ) : (
        <EntityHistoryFeed
          items={filtered.map((item) => ({
            id: item.id,
            date: item.date,
            text: item.text,
            meta: item.actor,
            icon: item.kind === 'deal_stage_changed' ? <SwapOutlined /> : undefined,
          }))}
        />
      )}
    </>
  );
}
import { ErrorState } from '../../../shared/ui/ErrorState.js';
